<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            ADD - ANIMAL DISEASE DETAIL
          </h2>
          <!--<p>Create animal disease detail</p>-->
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
      </div>
      <br>
      <form class="row" [formGroup]="animal_disease">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Disease Name<span
                style="color: rgb(226, 69, 69); padding-left: 5px;">*</span></label>
            <input type="text" name="diseasename" id="diseasename" value="" class="form-control"
              [(ngModel)]="disease_name" [ngModelOptions]="{standalone: true}">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Drug Name<span
                style="color: rgb(226, 69, 69); padding-left: 5px;">*</span></label>
            <input type="text" name="addrug" id="drugname" value="" class="form-control" [(ngModel)]="drug_name"
              [ngModelOptions]="{standalone: true}">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label for="fromage">Dose Value<span
                    style="color: rgb(226, 69, 69); padding-left: 5px;">*</span></label>
                <input type="number" id="dosevalue" name="adddose" class="form-control" min="0" max="50" step="1"
                  [ngModelOptions]="{standalone: true}" [(ngModel)]="dose_value">
                <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label for="toage">Units<span style="color: rgb(226, 69, 69); padding-left: 5px;">*</span></label>
                <input type="text" id="unit" name="adddose" class="form-control" [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="units">
                <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Date Of Discovery<span
                style="color: rgb(226, 69, 69); padding-left: 5px;">*</span></label>
            <input type="date" name="DiscoveryDate" id="DiscoveryDate" value="" class="form-control"
              [ngModelOptions]="{standalone: true}" [(ngModel)]="date_of_discovery">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Treatment Given<span
                style="color: rgb(226, 69, 69); padding-left: 5px;">*</span></label>
            <input type="text" id="TreatmentDate" name="Treatmentdate" class="form-control"
              [ngModelOptions]="{standalone: true}" [(ngModel)]="treatment_given">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Description</label>
            <textarea id="Description" name="Description" class="form-control"></textarea>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <button type="submit" class="btn btn-fill btn-primary mb-3" (click)="AnimalDisease()">Submit<div
              class="ripple-container"></div></button>
          <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>